module.exports = __webpack_public_path__ + "static/img/d-materials.8b2e5962.png";